import type { MessengerSmsViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetSmsViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerSmsViewSettings>(() => {
    const { suitableNumber, uiSettings } = widgetSettings.value.channels[WebWidgetChannelType.SMS]
    const { title, description, buttonText } = uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.SMS],
      suitableNumber,
      title,
      description,
      buttonText,
      showQrCode: uiSettings.showQrCode,
    } satisfies MessengerSmsViewSettings
  })
}
